import { memo } from 'react'

import { TradeScreen } from '@root/features/explore-v2/ui/trade-screen/trade-screen'

/**
 * The token page in the V2 language, mounted the way the board is: its own
 * screen rather than a page inside the terminal's shell.
 */
export const TradeV2Page: React.FC = memo(() => <TradeScreen />)
